import { ENDPOINTS } from 'shared/constants';
import { httpClientAuthorized } from '../httpClient';
import { GetRefsResponse, LeagueInfo } from 'shared/types';

type GetRefsParams = {
  limit: number;
  offset: number;
  level?: number;  // Опциональный для поиска
  get_referrer_promo_link?: boolean;
};

export const getRefs = async ({
  level,
  offset,
  limit,
  get_referrer_promo_link = false,
}: GetRefsParams) => {
  return await httpClientAuthorized.get<GetRefsResponse>(
    ENDPOINTS.GET_REFERALS(limit, offset, level, get_referrer_promo_link),
  );
};

export const acceptInvite = async (referrer_id: number) => {
  return await httpClientAuthorized.post<void>(ENDPOINTS.ACCEPT_INVITE, {
    referrer_id,
  });
};

export const getLeagueInfo = async () => {
  return await httpClientAuthorized.get<LeagueInfo>(ENDPOINTS.LEAGUE_INFO);
};

export const updateLeagueInfo = async () => {
  return await httpClientAuthorized.post<LeagueInfo>(ENDPOINTS.LEAGUE_INFO);
};

// New endpoints for v2 friends module

export interface ReferralCounts {
  total: number;
  total_don_rewards: string;
  total_usdt_rewards: string;
  by_level: {
    [level: string]: number;
  };
}

export interface ReferralLevelStats {
  total_count: number;
  active_count: number;
  don_rewards: string;
  usdt_rewards: string;
}

// Get lightweight counts for initial page load
export const getReferralsCounts = async () => {
  return await httpClientAuthorized.get<ReferralCounts>(ENDPOINTS.REFERRALS_COUNTS);
};

// Get detailed stats for a specific level
export const getReferralLevelStats = async (level: number) => {
  return await httpClientAuthorized.get<ReferralLevelStats>(
    ENDPOINTS.REFERRAL_LEVEL_STATS,
    { params: { level } }
  );
};

export interface SearchReferralsParams {
  query: string;
  level?: number; // Optional: search within specific level only
  limit?: number;
  offset?: number;
}

export interface SearchReferralsResponse {
  count: number;
  data: GetRefsResponse['data']; // Use existing type
}

// Search referrals by username/nickname with sorting support
export const searchReferrals = async (params: SearchReferralsParams & {
  sort_field?: 'don' | 'usdt' | 'date';
  is_desc?: boolean;
}) => {
  const { sort_field = 'date', is_desc = true } = params;
  
  const queryParams = new URLSearchParams({
    query: params.query,
    ...(params.level !== undefined && { level: params.level.toString() }),
    limit: (params.limit || 20).toString(),
    offset: (params.offset || 0).toString(),
    sort_field: sort_field,
    is_desc: is_desc.toString(),
  });

  return await httpClientAuthorized.get<SearchReferralsResponse>(
    `${ENDPOINTS.SEARCH_REFERRALS}?${queryParams.toString()}`,
  );
};

// Get referrals with sorting and optional search
export interface GetRefsSortedParams extends GetRefsParams {
  sort_field?: 'don' | 'usdt' | 'date';
  is_desc?: boolean;
  search_query?: string;  // Добавляем поиск!
}

export const getRefsSorted = async (params: GetRefsSortedParams) => {
  const { 
    level, 
    offset, 
    limit, 
    get_referrer_promo_link = false, 
    sort_field = 'date', 
    is_desc = true,
    search_query 
  } = params;

  const queryParams = new URLSearchParams({
    limit: limit.toString(),
    offset: offset.toString(),
    get_referrer_promo_link: get_referrer_promo_link.toString(),
    sort_field: sort_field,
    is_desc: is_desc.toString(),
  });

  // Добавляем level только если указан (не при поиске)
  if (level !== undefined && !search_query) {
    queryParams.append('level', level.toString());
  }
  
  // Добавляем search_query только если он есть
  if (search_query) {
    queryParams.append('search_query', search_query);
  }

  return await httpClientAuthorized.get<GetRefsResponse>(
    `/v1/referrals/?${queryParams.toString()}`,
  );
};
